import api from '@/api';

export default class Form {
  constructor(data) {
    this.originalData = data;
    // eslint-disable-next-line
    for (const field in data) {
      this[field] = data[field];
    }
  }

  post(url) {
    return new Promise((resolve, reject) => {
      this.submit('post', url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  data() {
    const data = {};
    // eslint-disable-next-line
    for (const field in this.originalData) {
      data[field] = this[field];
    }
    return data;
  }

  submit(method, url) {
    return new Promise((resolve, reject) => {
      api[method](url, this.data())
        .then((response) => {
          Form.onSuccess(response.data);
          resolve(response.data);
        })
        .catch((error) => {
          Form.onFailure(error);
          reject(error.response.data);
        });
    });
  }

  // eslint-disable-next-line
  static onSuccess(data) {
    return true;
  }

  // eslint-disable-next-line
  static onFailure (error) {
    return true;
  }
}
